const contactUsPageStyle = {
send:{
    marginTop:"20px",
    textAlign:"right"
   }
}
export default contactUsPageStyle;